// Sun controller for the awning visualizer.
// Wraps the existing pergola SunSimulator (pure logic, SunCalc-based) so we
// reuse the validated azimuth/altitude math and the manual-azimuth override.

import { SunSimulator } from '../../SunSimulator.js';

// Approximate centroids per state for rough sun-path realism.
// (Final proposals always come from on-site, so per-city accuracy isn't needed.)
const STATE_COORDS = {
  NJ: { lat: 40.83, lng: -74.24 },   // Verona — Breslow HQ
  NY: { lat: 40.71, lng: -74.00 },   // Manhattan
  CT: { lat: 41.05, lng: -73.54 },   // Stamford
  PA: { lat: 40.00, lng: -75.20 },   // Philadelphia suburbs
};

const STATE_FALLBACK = STATE_COORDS.NJ;

export class AwningSun {
  constructor() {
    this.sim = new SunSimulator();
    this.sim.enabled = true;          // always on for the awning visualizer
    // Default to 3 PM mid-July — the moment the awning is most needed.
    this.sim.setTimeMinutes(900);
    this.sim.setDateFromString(`${new Date().getFullYear()}-07-15`);
  }

  setStateCoord(stateAbbr) {
    const c = STATE_COORDS[stateAbbr] || STATE_FALLBACK;
    this.sim.setLocation(c.lat, c.lng);
  }

  setTimeMinutes(t) { this.sim.setTimeMinutes(t); }
  setDateFromString(s) { this.sim.setDateFromString(s); }
  setManualAzimuth(deg) { this.sim.manualAzimuth = deg; }
  clearManualAzimuth() { this.sim.manualAzimuth = null; }
  setFacingDegrees(deg) { this.sim.setPergolaFacing(deg); }

  getLightParams() { return this.sim.getLightParams(); }
  getTimeDisplay() { return this.sim.getTimeDisplay(); }
  getDateInputValue() { return this.sim.getDateInputValue(); }
  isManual() { return this.sim.manualAzimuth !== null; }
}
